import React from "react"
import classNames from "classnames"

import styles from "./index.module.less"

interface Props {
    cross?: boolean
    value?: string | number
    className?: string
}

const Count: React.FC<Props> = (props) => {
    const { cross = true, value, className } = props

    return (
        <div className={classNames(styles.count, className)}>
            {cross ? <span className={styles.cross}>x</span> : null}
            <span className={styles.value}>{value || 0}</span>
        </div>
    )
}

export default Count
